import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getRecentBookmarks } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

interface BookmarkItem {
  bookmarked_at: string;
  shipment_updated_at: string | null;
  quote_request_statuses: string[];
  shipment_status: number;
  shipment_reference_number: string;
  shipment_title: string;
  shipment_created_at: string;
  is_lost: boolean;
}

interface QuoteRequestBookmarkGroup {
  type: "quote_request";
  data: BookmarkItem[];
}

interface ShipmentBookmarkGroup {
  type: "shipment";
  data: BookmarkItem[];
}

type BookmarksResponse = [QuoteRequestBookmarkGroup, ShipmentBookmarkGroup];

const useGetBookmarks = (options?: UseQueryOptions<BookmarksResponse>) =>
  useQuery<BookmarksResponse>({
    queryKey: [userQueryKeys.bookmarkWidget],
    queryFn: () => getRecentBookmarks().then((res) => res.data),
    staleTime: 300000,
    ...options,
  });

export default useGetBookmarks;
